import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'ops-info-tooltip',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './ops-info-tooltip.component.html',
  styleUrls: ['./ops-info-tooltip.component.scss'],
})
export class OpsInfoTooltipComponent {
  @Input() title?: string;
  @Input() text: string;
  @Input() tooltipVisible: boolean = false;
  @Input() tooltipBottom: boolean = false;

  @Output() onLeave: EventEmitter<void> = new EventEmitter<void>();
  @Output() onEnter: EventEmitter<void> = new EventEmitter<void>();

  @HostListener('mouseenter') onMouseEnter() {
    this.onEnter.emit();
  }

  @HostListener('mouseleave') onMouseLeave() {
    this.onLeave.emit();
  }
}
